export default __webpack_public_path__ + "static/media/titleVana.66a368eb.webp";